import { WarningToast } from "../../ToastComponent/RectHotToast";

export function checkErrors(data) {
  // Variable to track whether an alert has been displayed
  let alertDisplayed = false;
  let notification = null

  // Function to check if a value is present in the provided data
  const hasValue = (value) => value !== undefined && value !== null && value !== "";

  // Function to check nested structure of the object
  const checkNested = (obj) => {
    for (const key in obj) {
      const value = obj[key];

      // If the value is an object, recursively check its nested structure
      if (typeof value === "object" && value !== null) {
        checkNested(value);
      } else {
        // If the value is present and no alert has been displayed, display an alert
        if (hasValue(value) && !alertDisplayed) {
          WarningToast(`Error: ${key} is ${value}`);
          notification= `Error: ${key} is ${value}`
          alertDisplayed = true; // Set the flag to true after the first alert
        }
      }
    }
  };

  // Start checking the nested structure from the top-level object
  checkNested(data);
  return notification
}
